import type { HTMLAttributes, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils/cn';

const badgeVariants = cva('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', {
  variants: {
    variant: {
      default: 'bg-bg-subtle text-text-secondary dark:bg-bg-subtle dark:text-text-muted',
      primary: 'bg-bg-accent-muted text-text-accent dark:bg-bg-accent-muted dark:text-text-accent-hover',
      success: 'bg-feedback-success/10 text-feedback-success dark:bg-feedback-success/20 dark:text-feedback-success',
      warning: 'bg-feedback-warning/10 text-feedback-warning dark:bg-feedback-warning/20 dark:text-feedback-warning',
      danger: 'bg-feedback-error/10 text-feedback-error dark:bg-feedback-error/20 dark:text-feedback-error',
      info: 'bg-feedback-info/10 text-feedback-info dark:bg-feedback-info/20 dark:text-feedback-info',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export { badgeVariants };

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {
  children: ReactNode;
}

export function Badge({ className, variant, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {children}
    </span>
  );
}
